import { FC } from 'react';
import { Dialog, Box, Typography } from '@mui/material';
import { AnnouncementDto } from '../../types/announcement';

interface AnnouncementTextDialogProps {
    handleClose: () => void;
    open: boolean;
    announcement?: AnnouncementDto;
}

const AnnouncementTextDialog: FC<AnnouncementTextDialogProps> = (props) => {
    const { announcement, open, handleClose } = props;

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={{ p: 2 }}>
                <Typography>
                    {announcement?.text}
                </Typography>
            </Box>
        </Dialog>
    );
};

export default AnnouncementTextDialog;